// extracted by mini-css-extract-plugin
module.exports = {"container":"Agreement_container__2mqi3"};